import { siteConfig, IMAGES } from "@/data/siteConfig";
import { Reveal, scrollToId } from "./shared";
import { ArrowRight } from "lucide-react";

export const FounderSection = () => {
  const { founderData } = siteConfig;
  return (
    <section id="founder" data-testid="founder-section" className="bg-cream py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <img
                src={IMAGES.founder}
                alt="Ollie Howie, Founder"
                className="w-full h-[560px] object-cover object-top grayscale-[15%]"
              />
              <div className="absolute -bottom-6 -right-6 hidden bg-gold px-8 py-6 lg:block">
                <p className="font-display text-2xl text-navy">Ollie Howie</p>
                <p className="text-xs uppercase tracking-[0.2em] text-navy/70">Founder</p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">{founderData.eyebrow}</p>
              <h2 className="font-display text-4xl font-semibold tracking-tight text-navy sm:text-5xl">
                {founderData.name}
              </h2>
              <p className="mt-3 text-lg text-charcoal/70">{founderData.title}</p>
              <div className="mt-8 space-y-5">
                {founderData.bio.map((p, i) => (
                  <p key={i} className="text-base leading-relaxed text-charcoal/80 md:text-lg">{p}</p>
                ))}
              </div>
              <div className="mt-10 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-3">
                {founderData.facts.map((f, i) => (
                  <div key={i} className="bg-cream p-6">
                    <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-2">{f.label}</p>
                    <p className="text-sm font-semibold text-navy">{f.value}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export const MidCTA = () => (
  <section data-testid="mid-cta" className="bg-navy py-24 grain relative overflow-hidden">
    <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12 text-center">
      <Reveal>
        <h2 className="mx-auto max-w-4xl font-display text-4xl font-semibold leading-tight text-cream sm:text-5xl lg:text-6xl">
          Your future is worth building. Begin the work.
        </h2>
        <button
          data-testid="mid-apply-btn"
          onClick={() => scrollToId("#apply")}
          className="group mt-10 inline-flex items-center gap-3 bg-gold px-10 py-4 text-sm font-semibold tracking-wide text-navy transition-colors duration-300 hover:bg-cream"
        >
          {siteConfig.primaryCta}
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
